/* Search-only grid preferences; apply before restored results are measured. */
(() => {
  'use strict';
  if (customElements.get('faf-search-layout')) return;

  const storageKey = 'faf-search-layout-v1';
  const allowed = { mobile: ['1', '2'], desktop: ['3', '5'] };
  const preferences = { mobile: '1', desktop: '3' };
  try {
    const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
    Object.keys(allowed).forEach(device => {
      if (allowed[device].includes(saved?.[device])) preferences[device] = saved[device];
    });
  } catch { /* Defaults and in-page choices work when storage is unavailable. */ }

  function apply(root) {
    if (!root?.matches('[data-faf-search-page]')) return;
    root.dataset.fafGridMobile = preferences.mobile;
    root.dataset.fafGridDesktop = preferences.desktop;
    root.querySelectorAll('[data-faf-search-layout]').forEach(control => {
      control.querySelectorAll('button[data-grid-device][data-grid-columns]').forEach(button => {
        button.setAttribute('aria-pressed', String(preferences[button.dataset.gridDevice] === button.dataset.gridColumns));
      });
      control.hidden = !root.querySelector('[data-faf-search-product-list] > li[data-faf-search-product]');
    });
  }

  class SearchLayout extends HTMLElement {
    connectedCallback() { apply(this.closest('[data-faf-search-page]')); }
  }
  customElements.define('faf-search-layout', SearchLayout);

  document.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[data-faf-search-layout] button[data-grid-device][data-grid-columns]') : null;
    const root = button?.closest('[data-faf-search-page]');
    if (!root) return;
    const device = button.dataset.gridDevice;
    const columns = button.dataset.gridColumns;
    if (!allowed[device]?.includes(columns)) return;
    preferences[device] = columns;
    try { sessionStorage.setItem(storageKey, JSON.stringify(preferences)); } catch { /* Keep the active choice in memory. */ }
    apply(root);
    document.dispatchEvent(new CustomEvent('faf:search-layout-changed', { detail: { device, columns: Number(columns), root } }));
    requestAnimationFrame(() => window.FAFSearchPage?.savePosition?.());
  });
  document.addEventListener('faf:search-page-rendered', event => apply(event.detail?.root));
  document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-faf-search-page]').forEach(apply));
  window.addEventListener('pageshow', () => document.querySelectorAll('[data-faf-search-page]').forEach(apply));
})();
